import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Checkbox as MuiCheckbox, FormControlLabel, makeStyles } from '@material-ui/core'

import { ImageUpload, TextInput} from '../EditorFormElements'
import { Collapsible, FormFieldWrapper } from '../Global'

import makePath from '../../utils/makePath'
import { setItem } from '../../actions'
import { useDirty } from '../../hooks'
import generateId from '../../utils/generateId'



const useStyles = makeStyles((theme) => ({
  alignRight: {
    marginLeft: 'auto',
  }
}))


export const Choice = React.memo(({callback,correctChoice,feedbackForAll,index,given = {}, ...props}) => {
  
  const [id] = useState(generateId('choice-'));
  const path = makePath(props.path,index)

  const classes = useStyles();

  const [correct, setCorrect] = useState(correctChoice === id);

  const dispatch = useDispatch();
  const setDirty = useDirty();

  const onCheckboxChange = (name, value) => {
    setCorrect(value);
    setDirty();
  }

  // Update parent when "correct" value changes.
  // Keeps title in sync and allows parent to control unchecking
  // other "correct" checkboxes when one is checked
  useEffect(() => {
    if (correct) {
      callback(id,correct)
    }
  },[callback,correct,id])

  // Set this checkbox to unchecked if parent question informs
  // choice that a different choice has been marked correct.
  useEffect(() => {
    if (correctChoice && correctChoice !== id) {
      setCorrect(false);
    }
  },[correctChoice,id])

  // Update store when value of "correct" changes
  useEffect(() => {
    dispatch(setItem( makePath(path,'correct') , correct));

    // Delete feedback if only correct answers get feedback and this
    // is an incorrect answer
    if (!feedbackForAll && !correct) {
      dispatch(setItem( makePath(path,'feedback'), null));
    }

  },[correct,dispatch,feedbackForAll,path])

  // Set initial value from provided value
  useEffect(() => {
    if (given.correct) {
      setCorrect(given.correct);
    }
  }, [given]);


  // Present text or image options depending on question format
  const renderChoiceType = () => {
    if (props.format === 'text') {
      return <TextInput 
              name="text"
              given={given.text}
              multiline
              rows={3}
              label="Answer Choice"
              placeholder="Provide text to display as an answer option."
              defaultText="Enter answer choice text"
              path={path}
            />
    }
    else if (props.format === 'image') {
      return <ImageUpload 
                name="image"
                label="Answer Choice Image"
                tooltip="Upload an image to display as the answer choice. Must not exceed 330px in width and not exceed 75KB."
                includeAlt={true}
                altLabel="Image Alt Text"
                altPlaceholder="Provide image alt text that describes image to support screen readers."
                path={path}
                given={given.image}
              /> 
    } else {
      return <div></div>
    }

  }
  
  return (
    <Collapsible sortableChild grayTheme title={`Answer Choice ${index + 1}${correct ? ' (Correct)' : ''}`}>

      <FormFieldWrapper>

        <FormControlLabel
          className={ classes.alignRight }
          control={
            <MuiCheckbox
              // {...props}
              size="small"
              checked={correct}
              onChange={onCheckboxChange}
              name="correct"
              color="primary"
            />
          }
          label="Correct Answer"
        />

      </FormFieldWrapper>
      
      <FormFieldWrapper>

        { renderChoiceType() }

        {correct || feedbackForAll ?
          <TextInput 
            name="feedback"
            label="Answer Feedback"
            multiline
            rows={3}
            given={given.feedback}
            placeholder="Provide text to display as feedback."
            path={path}
          /> 
        : '' }

      </FormFieldWrapper>
    

      {props.deleteBtn}

    </Collapsible>
  )
  
})